import { z } from 'zod'

export const rebalancingPlanItemSchema = z.object({
  instrumentUid: z.string(),
  ticker: z.string().nullable(),
  instrumentName: z.string().nullable(),
  currentPercent: z.number(),
  targetPercent: z.number(),
  deviation: z.number(),
  currentValue: z.number(),
  targetValue: z.number(),
  lotsToTrade: z.number().int(),
  lotSize: z.number().int(),
  averagePrice: z.number().nullable(),
  currentPrice: z.number(),
  effectivePrice: z.number(),
  estimatedCost: z.number(),
  feeAmount: z.number(),
})

export type RebalancingPlanItemDto = z.infer<typeof rebalancingPlanItemSchema>

export const rebalancingPlanResponseSchema = z.object({
  items: z.array(rebalancingPlanItemSchema),
  totalPortfolioValue: z.number(),
  availableCash: z.number(),
  budgetWarning: z.boolean(),
  totalBuyCost: z.number(),
  totalSellProceeds: z.number(),
  totalFees: z.number(),
  netCost: z.number(),
  wasScaled: z.boolean(),
})

export type RebalancingPlanResponseDto = z.infer<typeof rebalancingPlanResponseSchema>
